module.exports = __webpack_public_path__ + "img/standchecklist.7da619ea.svg";